import { Component, input, AfterViewInit, ElementRef } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const POSITION_STATIC = 'static';
const POSITION_RELATIVE = 'relative';

@Component({
  selector: 'debtor-panel-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [MatProgressSpinnerModule],
})
export class LoadingSpinnerComponent implements AfterViewInit {
  public isLoading = input.required<boolean>();

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const parent = this.el.nativeElement.parentElement;
    if (parent) {
      const computedStyle = window.getComputedStyle(parent);
      if (computedStyle.position === POSITION_STATIC) {
        parent.style.position = POSITION_RELATIVE;
      }
    }
  }
}